const productData = JSON.parse(document.getElementById("product-data").textContent);

let selectedRegion = null;
let selectedVariantId = null;
let selectedIndexId = null;
let regionLowestPrices = {};
let personDataStore = {};
let isInitializing = true;          // 👈 ADD THIS
const propheticCheckbox = document.getElementById("prophetic-checkbox");

// ======================
// POPULAR SHARE CONFIG
// Map each region to the qurbani count that should be marked "Popular"
// Change the number to move the badge to a different share within that region.
// Set a region to null to disable the popular badge for that region.
// ======================
const POPULAR_SHARES = {
  "Where Most Needed": 5,
  "Pakistan": 4,
  "Palestine": 2,
  "Yemen": 4,
  "Lebanon": 2,
  "Bangladesh": 5,
  "Egypt": 2,
  "Africa": 5
};

const POPULAR_SHARES_PROPHETIC = {
  "Where Most Needed": 10,
  "Pakistan": 8,
  "Palestine": 4,
  "Yemen": 8,
  "Lebanon": 4,
  "Bangladesh": 10,
  "Egypt": 10,
  "Africa": 4
};

// ======================
// URL VARIANT
// ======================
const urlVariant = new URLSearchParams(window.location.search).get("variant");

// ======================
// PRICE FORMAT
// ======================
function formatMoney(cents) {
  return (cents / 100).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

// ======================
// CURRENCY SYMBOL
// ======================
const currencySymbol = window.Shopify?.currency?.active
  ? new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: window.Shopify.currency.active
    }).format(0).replace(/[0-9.,\s]/g, "")
  : "";

// ======================
// HEADER UPDATE
// ======================

// ======================
// SCROLL ACTIVE INTO VIEW (horizontal only — won't move page)
// ======================
function scrollActiveIntoView(container, activeEl) {
  if (!container || !activeEl) return;

  const containerRect = container.getBoundingClientRect();
  const elRect = activeEl.getBoundingClientRect();

  // element position relative to container's scroll origin
  const elOffset = elRect.left - containerRect.left + container.scrollLeft;

  // center the element inside the container
  const target = elOffset - (container.clientWidth / 2) + (elRect.width / 2);

  container.scrollTo({
    left: Math.max(0, target),
    behavior: "smooth"
  });
}


function enableDragScroll(container) {
  if (!container) return;

  let isDown = false;
  let startX = 0;
  let scrollLeftStart = 0;
  let hasDragged = false;
  let pendingScrollLeft = null;
  let rafId = null;
  const DRAG_THRESHOLD = 5;

  function applyScroll() {
    if (pendingScrollLeft !== null) {
      container.scrollLeft = pendingScrollLeft;
      pendingScrollLeft = null;
    }
    rafId = null;
  }

  container.addEventListener("mousedown", (e) => {
    if (e.button !== 0) return;
    isDown = true;
    hasDragged = false;
    startX = e.pageX - container.offsetLeft;
    scrollLeftStart = container.scrollLeft;
    container.classList.add("is-dragging");
  });

  const stopDrag = () => {
    if (!isDown) return;
    isDown = false;
    container.classList.remove("is-dragging");
  };

  container.addEventListener("mouseleave", stopDrag);
  container.addEventListener("mouseup", stopDrag);
  // also catch release outside the container
  window.addEventListener("mouseup", stopDrag);

  container.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();

    const x = e.pageX - container.offsetLeft;
    const walk = x - startX;

    if (Math.abs(walk) > DRAG_THRESHOLD) {
      hasDragged = true;
    }

    pendingScrollLeft = scrollLeftStart - walk;

    if (rafId === null) {
      rafId = requestAnimationFrame(applyScroll);
    }
  });

  container.addEventListener("click", (e) => {
    if (hasDragged) {
      e.preventDefault();
      e.stopPropagation();
      hasDragged = false;
    }
  }, true);

  container.addEventListener("wheel", (e) => {
    if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
      e.preventDefault();
      container.scrollLeft += e.deltaY;
    }
  }, { passive: false });
}

enableDragScroll(document.getElementById("region-options"));
enableDragScroll(document.getElementById("quantity-options"));


function updateHeader(region, price) {
  const regionEl = document.querySelector(".locaqb");
  const priceEl = document.querySelector(".flagbr");

  if (regionEl) {
    if (region === "Where Most Needed") {
      regionEl.innerHTML = `Where Most Needed <span class="normal">for</span>`;
    } else {
      regionEl.innerHTML = `<span class="normal">in</span> ${region}`;
    }
  }

  if (priceEl) {
    priceEl.innerText = price
      ? currencySymbol + formatMoney(price)
      : "";
  }
}

// ======================
// REGIONS
// ======================
const regions = [...new Set(productData.variants.map(v => v.option1))];

function getShares(region) {
  return productData.variants
    .filter(v => {
      const option = v.option2.toLowerCase();

      const isPropheticOrUmmah =
        option.includes("prophetic") || option.includes("ummah");

      if (propheticCheckbox.checked) {
        return v.option1 === region && isPropheticOrUmmah;
      } else {
        return v.option1 === region && !isPropheticOrUmmah;
      }
    })
    .map((v, i) => ({
      index: i,
      label: v.option2,
      count: parseInt(v.option2.match(/\d+/)[0]),
      variantId: v.id,
      price: v.price,
      available: v.available
    }));
}

// ======================
// IS POPULAR SHARE
// ======================
function isPopularShare(region, count) {
  const map = propheticCheckbox.checked
    ? POPULAR_SHARES_PROPHETIC
    : POPULAR_SHARES;

  const popularCount = map[region];
  return popularCount != null && popularCount === count;
}

// ======================
// TOGGLE
// ======================
propheticCheckbox.addEventListener("change", () => {
  regionLowestPrices = getLowestRegionPrices();
  renderRegions();

  // if (!selectedRegion) return;

  // Reset selectedIndexId so the popular share (or first available) is picked
  // fresh in the new mode instead of re-using the previous mode's index.
  // selectedIndexId = null;

  renderShares(selectedRegion);

  const shares = getShares(selectedRegion);
  if (shares.length > 0) {
    updateHeader(selectedRegion, shares[0].price);
  }
});

// ======================
// RENDER REGIONS
// ======================
function renderRegions() {
  const container = document.getElementById("region-options");
  container.innerHTML = "";

  const regionFlags = {
    'Where Most Needed': "alrt",
    Pakistan: "pk",
    Palestine: "ps",
    Yemen: "ye",
    Lebanon: "lb",
    Bangladesh: "bd",
    Egypt: "eg",
    Africa: "ele"
  };

  regions.forEach((region, index) => {
    const wrapper = document.createElement("div");
    wrapper.classList.add("combine_wrp");

    const btn = document.createElement("button");
    btn.classList.add("country");

    btn.innerHTML = `${region} <span class="fi fi-${regionFlags[region] || ""}"></span>`;

    if (selectedRegion === region) {
      btn.classList.add("active");
    }

    btn.onclick = () => selectRegion(region, btn);

    const priceDiv = document.createElement("div");
    priceDiv.classList.add("srtfrom");

    const price = regionLowestPrices[region];
    priceDiv.innerText = price
      ? `Only ${currencySymbol}${formatMoney(price)}`
      : "";

    wrapper.appendChild(btn);
    wrapper.appendChild(priceDiv);

    container.appendChild(wrapper);

    if (!urlVariant && index === 0 && !selectedRegion) {
      selectRegion(region, btn);
    }
  });
}

// ======================
// SELECT REGION
// ======================
function selectRegion(region, btnElement) {
  // When switching to a new region, clear the previous share index so the
  // new region's popular share (or first available) is picked fresh.
  if (selectedRegion !== region) {
    selectedIndexId = null;
  }

  selectedRegion = region;

  // ======================
// CUT OFF CHECK (DISABLE BUTTON)
// ======================
const addToCartBtn = document.getElementById("add-to-cart-btn");

if (isCutOff(region)) {
  addToCartBtn.disabled = true;
  addToCartBtn.classList.add("disabled");
  addToCartBtn.innerText = "Not Available";
} else {
  addToCartBtn.disabled = false;
  addToCartBtn.classList.remove("disabled");
  addToCartBtn.innerText = isDonationItem ? "Donate Now!" : "Add to Cart";
}

  document.querySelectorAll("#region-options button")
    .forEach(b => b.classList.remove("active"));

  btnElement.classList.add("active");

  renderShares(region);

  const lowestPrice = regionLowestPrices[region];
  updateHeader(region, lowestPrice);

  // 👇 ADD THIS — scroll active region into view
  const regionContainer = document.getElementById("region-options");
  scrollActiveIntoView(regionContainer, btnElement.closest(".combine_wrp") || btnElement);

}



// ======================
// HEPLERS
// ====================== 

function isCutOff(region) {
  return (window.cutOffCountries || [])
    .includes((region || "").toLowerCase().trim());
}


// ======================
// LOWEST PRICE
// ======================
function getLowestRegionPrices() {
  const map = {};

  regions.forEach(region => {
    const shares = getShares(region);

    map[region] = shares.length
      ? Math.min(...shares.map(s => s.price))
      : null;
  });

  return map;
}

// ======================
// RENDER SHARES
// ======================
function renderShares(region) {
  const container = document.getElementById("quantity-options");
  container.innerHTML = "";

  const shares = getShares(region);

  let autoSelected = false;

  shares.forEach((item) => {
    const btn = document.createElement("button");

    btn.classList.add("slqrb");
    btn.setAttribute("data-variant-id", item.variantId);
    btn.setAttribute("data-index-id", item.index);

    let formattedLabel = item.label;

    if (item.label.toLowerCase().includes("for the ummah")) {
      const match = item.label.match(/^(\d+\s+Qurbanis?)\s+(.*?)\s*-\s*(.*)$/i);

      if (match) {
        formattedLabel = `
          <span>${match[1]}:</span>
          <span>${match[2]}, ${match[3]}</span>
        `;
      }
    }

    const popularBadge = isPopularShare(region, item.count)
      ? `<span class="popular-badge">Popular</span>`
      : "";

    btn.innerHTML = `
      <div class="combinebox">
        <div class="bderpc">○</div>
        <div class="qp">
          <div class="price">${currencySymbol}${formatMoney(item.price)}</div>
          <div class="qurbani">${formattedLabel}</div>
        </div>
        ${popularBadge}
      </div>
    `;

    if (!item.available) {
      btn.disabled = true;
      btn.classList.add("disabled");
    }

    btn.onclick = () => selectShare(item, btn);

    container.appendChild(btn);
  });

  // ======================
  // AUTO-SELECT (runs once, after all buttons exist)
  // Priority:
  //   1. Previously selected index (user's manual pick during session)
  //   2. URL ?variant= param
  //   3. Popular share for this region (if available)
  //   4. First available share
  // ======================
  let targetItem = null;

  if (selectedIndexId !== null) {
    targetItem = shares.find(s => s.index === selectedIndexId && s.available);
  }

  if (!targetItem && urlVariant) {
    targetItem = shares.find(s => s.variantId == urlVariant && s.available);
  }

  if (!targetItem) {
    targetItem = shares.find(
      s => isPopularShare(region, s.count) && s.available
    );
  }

  if (!targetItem) {
    targetItem = shares.find(s => s.available);
  }

  if (targetItem && !autoSelected) {
    const btnToClick = [...container.querySelectorAll(".slqrb")]
      .find(b => b.getAttribute("data-variant-id") == targetItem.variantId);

    if (btnToClick) {
      autoSelected = true;
      setTimeout(() => btnToClick.click(), 0);
    }
  }
}

// ======================
// SELECT SHARE
// ======================
function selectShare(item, btnElement) {
  selectedVariantId = item.variantId;
  selectedIndexId = item.index;

  const input = document.querySelector('input[name="id"]');
  if (input) input.value = item.variantId;

  document.querySelectorAll(".slqrb")
    .forEach(b => b.classList.remove("active"));

  btnElement.classList.add("active");

  let inputCount = item.count;

  if (propheticCheckbox.checked) {
    inputCount = Math.ceil(item.count / 2);
  }

  generateInputs(inputCount);

  updateVariantURL(item.variantId);
  updateVariantImage(item.variantId);
  updateHeader(selectedRegion, item.price);


  // 👇 ADD THIS — scroll active share into view
  const shareContainer = document.getElementById("quantity-options");
  scrollActiveIntoView(shareContainer, btnElement);

  // 👇 restore page scroll if something tried to move it
  if (savedScroll !== null) {
    const restore = () => {
      if (Math.abs(window.scrollY - savedScroll) > 2) {
        window.scrollTo({ top: savedScroll, left: 0, behavior: 'instant' });
      }
    };
    requestAnimationFrame(restore);
    setTimeout(restore, 50);
    setTimeout(restore, 150); // some Shopify handlers scroll async
  }

}

// ======================
// INPUT SYSTEM
// ======================
function generateInputs(count) {
  let wrapper = document.querySelector(".person-wrapper");

  if (!wrapper) {
    wrapper = document.createElement("div");
    wrapper.classList.add("person-wrapper");

    for (let i = 1; i <= 10; i++) {
      const field = document.createElement("div");
      field.classList.add("person-field");
      field.innerHTML = `
        <label>${i}</label>
        <input type="text" class="person-name" data-index="${i}" placeholder="Full Name (optional)">
      `;
      field.style.display = "none";
      wrapper.appendChild(field);
    }

    const target = document.querySelector(".presnet_input");
    if (target) target.appendChild(wrapper);
  }

  const fields = wrapper.querySelectorAll(".person-field");

  fields.forEach((field, index) => {
    const input = field.querySelector("input");

    if (index < count) {
      field.style.display = "flex";
    } else {
      field.style.display = "none";
      if (input) input.value = "";
    }
  });
}

// ======================
// URL + IMAGE
// ======================
function updateVariantURL(variantId) {
  const url = new URL(window.location.href);
  url.searchParams.set("variant", variantId);
  window.history.replaceState({}, "", url);
}

function updateVariantImage(variantId) {
  // 🔑 During initial page load Dawn already has the correct variant
  // selected and image showing. Dispatching change here re-fires Dawn's
  // full variant pipeline and can trigger cart-upsell / external scripts
  // that touch the cart. Skip on init.
  if (isInitializing) return;

  const variant = productData.variants.find(v => v.id == variantId);
  if (!variant) return;

  const variantSelects = document.querySelector('variant-selects');
  if (!variantSelects) return;

  const fieldsets = variantSelects.querySelectorAll('fieldset');

  fieldsets.forEach((fieldset, index) => {
    const value = variant.options[index];
    const input = [...fieldset.querySelectorAll('input')]
      .find(r => r.value === value);
    if (input) input.checked = true;
  });

  variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
}

// ======================
// ADD TO CART (FIXED)
// ======================

const btn = document.getElementById("add-to-cart-btn");
const isDonationItem = window.isDonationItem;

btn.addEventListener("click", () => {

  // 🔴 SAFE FALLBACK
  if (!selectedVariantId) {
    const activeBtn = document.querySelector(".slqrb.active");
    if (activeBtn) {
      selectedVariantId = activeBtn.getAttribute("data-variant-id");
    }
  }

  if (!selectedVariantId) {
    btn.innerText = "Select option first";
    return;
  }

  btn.innerText = "Adding...";
  btn.disabled = true;

  const properties = {};
  const quantityInput = document.querySelector(".quantity__input");
  const quantity = quantityInput ? parseInt(quantityInput.value || 1) : 1;

  document.querySelectorAll(".presnet_input .person-name").forEach(input => {
    if (input.value.trim()) {
      properties[`Person ${input.dataset.index}`] = input.value;
    }
  });

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: selectedVariantId,
      quantity,
      properties,
      sections: "cart-drawer,cart-icon-bubble",
      sections_url: window.location.pathname
    })
  })
  .then(res => {
    if (!res.ok) return Promise.reject(res);
    return res.json();
  })
  .then((data) => {
    btn.innerText = "Added";

    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartDrawer.renderContents(data);
      cartDrawer.classList.remove("is-empty"); // 🔑 critical for first-item case
      cartDrawer.open();
    }


    


    setTimeout(() => {
      btn.innerText = isDonationItem ? "Donate Now!" : "Add to Cart";
      btn.disabled = false;
    }, 1000);
  })
  .catch(() => {
    btn.innerText = "Try Again";
    btn.disabled = false;
  });

  
});



// ======================
// MOBILE: stop media-gallery from scrolling page on variant change
// ======================
(function patchMediaGallery() {
  if (window.innerWidth > 768) return;

  const MediaGalleryClass = window.customElements.get('media-gallery');

  if (!MediaGalleryClass) {
    window.customElements.whenDefined('media-gallery').then(patchMediaGallery);
    return;
  }

  MediaGalleryClass.prototype.setActiveMedia = function (mediaId, prepend) {
    const activeMedia = this.elements.viewer.querySelector(
      `[data-media-id="${mediaId}"]`
    );
    if (!activeMedia) return;

    // Deactivate all media
    this.elements.viewer.querySelectorAll('[data-media-id]')
      .forEach(el => el.classList.remove('is-active'));

    activeMedia.classList.add('is-active');

    // Move media to front so it's visible in viewer
    if (prepend) {
      this.elements.viewer.prepend(activeMedia);
      if (this.elements.thumbnails) {
        const activeThumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${mediaId}"]`
        );
        if (activeThumbnail) {
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
      }
    }

    // Pause non-active media
    this.elements.viewer.querySelectorAll('video, iframe').forEach((media) => {
      const parent = media.closest('[data-media-id]');
      if (parent && parent !== activeMedia && media.pause) {
        media.pause();
      }
    });

    // ======================
    // THUMBNAIL UPDATE
    // ======================
    if (!this.elements.thumbnails) return;

    const activeThumbnail = this.elements.thumbnails.querySelector(
      `[data-target="${mediaId}"]`
    );

    if (!activeThumbnail) return;

    // Dawn's setActiveThumbnail (if it exists) handles aria states correctly
    if (typeof this.setActiveThumbnail === 'function') {
      this.setActiveThumbnail(activeThumbnail);
    } else {
      // Fallback: manually set active state Dawn-style
      this.elements.thumbnails
        .querySelectorAll('[data-target] button, button[data-target]')
        .forEach((btn) => {
          btn.setAttribute('aria-current', 'false');
        });

      const btn = activeThumbnail.querySelector('button') ||
                  (activeThumbnail.tagName === 'BUTTON' ? activeThumbnail : null);
      if (btn) btn.setAttribute('aria-current', 'true');
    }

    // 👇 THE KEY FIX: scroll the thumbnail into view INSIDE the slider track
    // (not the page — the slider's own horizontal scroll)
    const thumbnailSlider = activeThumbnail.closest('slider-component') ||
                            this.elements.thumbnails;

    if (thumbnailSlider) {
      const sliderList = thumbnailSlider.querySelector('ul, .slider') || thumbnailSlider;

      // Calculate horizontal offset inside the slider only
      const thumbRect = activeThumbnail.getBoundingClientRect();
      const sliderRect = sliderList.getBoundingClientRect();

      const currentScroll = sliderList.scrollLeft;
      const thumbOffsetInSlider = thumbRect.left - sliderRect.left + currentScroll;

      const targetScroll = thumbOffsetInSlider
        - (sliderList.clientWidth / 2)
        + (thumbRect.width / 2);

      sliderList.scrollTo({
        left: Math.max(0, targetScroll),
        behavior: 'smooth'
      });
    }

    this.announceLiveRegion?.(activeMedia, activeThumbnail.dataset.mediaPosition);
  };
})();

// ======================
// INIT
// ======================
function init() {
  regionLowestPrices = getLowestRegionPrices();

  if (urlVariant) {
    const variant = productData.variants.find(v => v.id == urlVariant);

    if (variant) {
      selectedRegion = variant.option1;
      renderRegions();

      setTimeout(() => {
        const regionBtn = [...document.querySelectorAll("#region-options button")]
          .find(b => b.innerText.includes(variant.option1));

        if (regionBtn) {
          regionBtn.click();

          setTimeout(() => {
            const shareBtn = document.querySelector(`[data-variant-id="${urlVariant}"]`);
            if (shareBtn) shareBtn.click();
            updateHeader(variant.option1, variant.price);

            // 🔑 init pipeline complete — future selectShare calls are user-initiated
            setTimeout(() => { isInitializing = false; }, 100);
          }, 100);
        } else {
          isInitializing = false;
        }
      }, 100);

      return;
    }
  }

  renderRegions();

  // Non-URL-variant path also auto-selects on first render — wait for that to settle
  setTimeout(() => { isInitializing = false; }, 200);
}

init();
